import { createSelector } from 'reselect';

import { GlobalAppState } from 'rdx/state';

import { ProviderPromotionsPermissions } from '../../../../common/all/api/gen/CampaignDeliveryProvider';

export const promotionPermissions = (state: GlobalAppState) => state.promotionsPermissions;

export const selectProviderPromotionsPermissions = createSelector(
  [promotionPermissions],
  (permissions): ProviderPromotionsPermissions => {
    return permissions.result;
  },
);
